module.exports = __webpack_public_path__ + "static/media/4.fff6ed68.svg";